import { render, staticRenderFns } from "./SinglePageElement.vue?vue&type=template&id=58157742&"
import script from "./SinglePageElement.vue?vue&type=script&lang=js&"
export * from "./SinglePageElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports